var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dlg-input-layout"},[_vm._t("default"),(_vm.$slots.summary)?[_vm._t("summary")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }